export interface HttpClientConfig {
  userToken: string
  baseUrl: string
  headers: {
    'apollographql-client-name': string
    'apollographql-client-version': string
    'apollographql-client-locale'?: string
  }
}

export class HttpClient {
  private config: HttpClientConfig

  constructor(config: HttpClientConfig) {
    this.config = config
  }

  private getHeaders(
    additionalHeaders?: Record<string, string>
  ): Record<string, string> {
    return {
      Authorization: this.config.userToken,
      'Content-Type': 'application/json',
      ...this.config.headers,
      ...additionalHeaders
    }
  }

  async get(url: string, options?: { signal?: AbortSignal }): Promise<any> {
    const response = await fetch(`${this.config.baseUrl}${url}`, {
      method: 'GET',
      headers: this.getHeaders(),
      signal: options?.signal
    })

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }

    return response.json()
  }

  async post(
    url: string,
    data?: any,
    options?: { signal?: AbortSignal; headers?: Record<string, string> }
  ): Promise<any> {
    const response = await fetch(`${this.config.baseUrl}${url}`, {
      method: 'POST',
      headers: this.getHeaders(options?.headers),
      body: data ? JSON.stringify(data) : undefined,
      signal: options?.signal
    })

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }

    return response.json()
  }

  // eslint-disable-next-line
  async put(
    url: string,
    data?: any,
    options?: { signal?: AbortSignal; headers?: Record<string, string> }
  ): Promise<any> {
    const response = await fetch(url, {
      method: 'PUT',
      headers: options?.headers || {},
      body: data,
      signal: options?.signal
    })

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }

    return response
  }
}

// eslint-disable-next-line
export const httpClient = (config: HttpClientConfig) => new HttpClient(config)
